module.exports = __webpack_public_path__ + "static/media/stroke.b05ef6ed.svg";